import React, { useMemo, useState } from "react";
import { useReportContext } from "../report_context";
import BulkActionBar from "../../BulkActionBar";

function ActionBar() {
  const {
    firstLoaded,
    totalRows,
    selectedRows,
    selectedRowsOverall,
    loading,
    reportConfig: { withSelection, bulkActions, disableMultiPageSelect }
  } = useReportContext();

  if (!withSelection || !bulkActions || !firstLoaded || loading || totalRows === 0) {
    return null;
  }

  return (
    <BulkActionBar
      selected={disableMultiPageSelect ? selectedRows : selectedRowsOverall.map(r => JSON.parse(r))}
      prepareLabel={bulkActions.prepareLabel}
      actions={bulkActions.actions}
    />
  );
}

export default ActionBar;
